// extracted by mini-css-extract-plugin
export default {"toggleButton":"SelectionToggle_toggleButton__RLjaS"};